import { createSelector } from 'reselect'

const selectAuth = state => state.auth

export const selectUserDetails = createSelector(selectAuth, authData => authData.user.data)